import { ComponentWarrantyList } from "src/Components/Pumkin/WarrantyList";

export const PageWarrantyList = () => {
    return <ComponentWarrantyList />;
};
